import request from '@/utils/request'

// 查询质量奖管理列表
export function listZlj(query) {
  return request({
    url: '/web/zlts/zlj/list',
    method: 'get',
    params: query
  })
}

// 查询质量奖管理详细
export function getZlj(recid) {
  return request({
    url: '/web/zlts/zlj/' + recid,
    method: 'get'
  })
}
